import { useEffect, useRef } from 'react';
import {
  DialogContent,
  DialogContentText,
  Typography,
  Button,
  useMediaQuery,
  Box,
} from '@mui/material';
import { useAccount } from '../../../contexts/Account';
import eventBus from '../../../eventBus';

const useStyles = () => ({
  dialogContent: {
    overflowY: 'visible',
    marginTop: { xxs: '0px', xs: '-30px' },
    padding: { xxs: '20px', xs: '16px 0px' },
    textAlign: 'center',
  },
  dialogTextCompanyName: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    maxWidth: '100%',
  },
  dialogTextCompanyNameContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
});

export default function Step4({ companyBoardData, handleClose }) {
  const { accountDetails } = useAccount();
  const isXS = useMediaQuery((theme) => theme.breakpoints.down('xs'));
  const classes = useStyles();

  const iframeRef = useRef(null);

  const handleReplay = () => {
    if (iframeRef.current) {
      iframeRef.current.src = iframeRef.current.src;
    }
  };

  useEffect(() => {
    // forcing animation replay
    eventBus.on('replayAnimation', handleReplay);
    return () => {
      eventBus.remove('replayAnimation', handleReplay);
    };
  }, []);

  return (
    <DialogContent sx={classes.dialogContent}>
      <div style={classes.dialogTextCompanyNameContainer}>
        <DialogContentText sx={classes.dialogTextCompanyName}>
          <Typography
            variant="caption"
            sx={{
              fontSize: '24px',
              lineHeight: '24px',
              letterSpacing: '-0.43px',
              textTransform: 'none',
              fontWeight: 700,
              color: '#232B35',
              verticalAlign: 'middle',
              marginTop: '32px',
            }}
          >
            {`${accountDetails.givenName}, thank you!`}
          </Typography>
        </DialogContentText>
      </div>
      <iframe
        ref={iframeRef}
        src="https://cdn.advisorycloud.com/static-content/loading-boardroom.html"
        title="Loading Profile"
        frameBorder="0"
        style={{
          width: isXS ? '380px' : '500px',
          overflowX: 'visible',
          marginTop: '16px',
        }}
      />
      <Typography
        sx={{
          fontSize: '48px',
          letterSpacing: '-0.43px',
          textAlign: 'center',
        }}
      >
        🎁
      </Typography>
      <Typography
        sx={{
          fontSize: '16px',
          letterSpacing: '-0.43px',
          textAlign: 'center',
          padding: { xxs: '0px 60px', xs: '0px' },
        }}
      >
        <span style={{ fontWeight: 700 }}>Just a reminder:</span> At 1 year of
        being on our board, we have a special thank you plaque and a few other
        special surprises coming your way!
      </Typography>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          mt: '32px',
        }}
      >
        <Button
          id={`enterBoardroom${companyBoardData?.displayName.replace(
            /\s+/g,
            ''
          )}`}
          variant="contained"
          color="primary"
          onClick={handleClose}
          className="getStartedButton"
          style={{
            backgroundColor: '#3578F4',
            paddingTop: 15,
            paddingBottom: 15,
            textTransform: 'none',
            fontWeight: 700,
            fontSize: 15,
            width: 180,
            height: 44,
            borderRadius: 30,
          }}
        >
          Enter Boardroom
        </Button>
      </Box>
    </DialogContent>
  );
}
